export const formatISOToBasicDateFormat = (oldDate: string):string => {
   let returnDate = new Date(oldDate);

   returnDate.setMinutes(returnDate.getMinutes() - returnDate.getTimezoneOffset());

   let returnISO = returnDate.toISOString();
   return returnISO.split("T")[0];
}